module.exports = __webpack_public_path__ + "media/images/badge/special-one-349ba5aa75bcab28f6906287c26208de.png";